import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import classNames from 'classnames';
import { apiHolder, apis, inWindow, locationHelper } from 'api';
import CopyToClipboard from 'react-copy-to-clipboard';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import styles from './detail_info.module.scss';
import cardStyles from '@web-im/common/usercard/userCard.module.scss';
import ContactTrackerIns from '../../tracker';
import { ReactComponent as CheckedCircleIcon } from '@/images/icons/checked_circle.svg';
import { ReactComponent as CloseCircleIcon } from '@/images/icons/close_circle.svg';
import { CopyIcon } from '@web-common/components/UI/Icons/icons';
import ScheduleModal from '@web-schedule/components/ScheduleModal/ScheduleModal';
import { MemberList } from '@web-contact/component/MemberList/MemberList';
import { api } from 'api';
import { useContactPersonalOrg } from '@web-common/hooks/useContactModel';
import { doGetContactData } from '@web-common/state/selector/contact';
import { getIn18Text } from 'api';
import dayjs from 'dayjs';
const sysApi = api.getSystemApi();
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const contactApi = apiHolder.api.requireLogicalApi(apis.contactApiImpl);
const ContactDetailInfo = props => {
    var _a;
    const { emailList, phoneList, contact, branch, directSend, visibleSchedule = true, onNotifyParent, isMainAccount = true, _account, detailRestricted } = props;
    const contactData = contact.contact;
    const personalOrg = contactData === null || contactData === void 0 ? void 0 : contactData.personalOrg;
    const { personalOrgNameList, hasDataOrgIds } = useContactPersonalOrg(personalOrg);
    const [selectedKeys] = useState2RM('selectedKeys');
    const [memberListVisible, setMemberListVisible] = useState(false);
    useEffect(() => {
        const personalOrgCount = (personalOrg === null || personalOrg === void 0 ? void 0 : personalOrg.length) || 0;
        const personalOrgNameListCount = (personalOrgNameList === null || personalOrgNameList === void 0 ? void 0 : personalOrgNameList.length) || 0;
        let hasDiff = false;
        if (!personalOrgCount) {
            hasDiff = false;
        }
        else if (!personalOrgNameListCount) {
            hasDiff = true;
        }
        else if (personalOrgCount !== hasDataOrgIds.length) {
            hasDiff = true;
        }
        else if (personalOrgCount === hasDataOrgIds.length) {
            hasDiff = personalOrg.some(orgId => !hasDataOrgIds.includes(orgId));
        }
        if (hasDiff) {
            doGetContactData({ personalOrg, _account });
        }
    }, [personalOrg]);
    const tooltipContainer = () => document.getElementById(contactData.id) || document.body;
    const sendMail = (email) => {
        if (directSend && email.length) {
            mailApi.doWriteMailToContact(email, _account);
        }
    };
    const checkMailRelated = (relatedContact) => {
        const fromAccount = (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId) || '';
        mailConfApi.doOpenRelatedPage(relatedContact, fromAccount);
    };
    const renderItems = (renderItemsProps) => {
        const { items, label, enableSend = false, enableVisit = false, showCopy = true, showPoint = false, toSchedule = false, toNumber = false, visibleMailRelated = false, type, } = renderItemsProps;
        return (React.createElement("div", { className: `${styles.infoRows} ${showCopy && styles.infoSingleRow}` },
            React.createElement("div", { className: styles.infoLabel }, label),
            React.createElement("div", { className: styles.infoContent, "data-test-id": `contact_detail_info_${type}_list` }, items.map(cell => (React.createElement("div", { className: styles.infoLine, key: cell, "data-test-id": `contact_detail_info_${type}_item` },
                React.createElement("span", { className: classNames(cardStyles.infoText, styles.infoText, {
                        [styles.infoLink]: enableSend || toSchedule || visibleMailRelated || toNumber || enableVisit,
                    }), onClick: () => {
                        onNotifyParent && onNotifyParent();
                        if (enableSend) {
                            sendMail([cell]);
                            ContactTrackerIns.tracker_contact_detail_click(getIn18Text('DIANJIYOUXIANGJIN'));
                        }
                        if (visibleMailRelated) {
                            checkMailRelated(contact);
                        }
                        if (enableVisit) {
                            sysApi.handleJumpUrl(0, cell);
                        }
                    } },
                    showPoint ? React.createElement("span", { className: styles.infoPoint }) : React.createElement(React.Fragment, null),
                    toSchedule && React.createElement(ScheduleModal, { user: contactData.accountName }),
                    toNumber && (React.createElement("span", { onClick: e => {
                            e.stopPropagation();
                            setMemberListVisible(true);
                        } }, getIn18Text('CHAKAN'))),
                    !toSchedule && !toNumber && cell),
                showCopy && (React.createElement(Tooltip, { getPopupContainer: tooltipContainer, overlayClassName: styles.tooltipOverlay, title: getIn18Text('FUZHI'), placement: "right" },
                    React.createElement("div", { className: classNames(styles.copyIcon) },
                        React.createElement(CopyToClipboard, { onCopy: (_, result) => {
                                message.success({
                                    icon: result ? React.createElement(CheckedCircleIcon, null) : React.createElement(CloseCircleIcon, null),
                                    content: (React.createElement("span", { style: {
                                            marginLeft: 8,
                                        } }, result ? getIn18Text('FUZHICHENGGONG') : getIn18Text('FUZHISHIBAI'))),
                                });
                                enableSend && ContactTrackerIns.tracker_contact_detail_click(getIn18Text('FUZHIYOUXIANGDE'));
                            }, text: cell },
                            React.createElement(CopyIcon, null)))))))))));
    };
    const visiblePhone = !detailRestricted && phoneList.length > 0;
    const visiblePosition = !detailRestricted && branch && contactData.type === 'enterprise' && Array.isArray(contactData.position) && contactData.position.length > 0;
    const visibleRemark = !!contactData.remark;
    const currentUser = (_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id;
    const inMainPage = inWindow() && locationHelper.testPathMatch('/');
    const visibleNumber = contactApi.isMailListByAccountType(contactData.accountType);
    const showSchedule = visibleSchedule && isMainAccount && inMainPage && contactData.type === 'enterprise' && contactData.accountName !== currentUser;
    const visibleMailRelated = contactData.accountName && contactData.accountName.length > 0;
    const visibleJob = !detailRestricted && contactData.type === 'enterprise' && contactData.job && contactData.job.length;
    const visibleAdrList = contactData.type === 'personal' &&
        contactData.adrList &&
        contactData.adrList.filter(item => {
            return item.trim().length > 0;
        }).length;
    const visibleBirthday = contactData.type === 'personal' && contactData.birthday;
    const visiblePref = contactData.type === 'personal' && contactData.pref;
    const visibleRole = contactData.type === 'personal' && contactData.role;
    const visibleTitle = contactData.type === 'personal' && contactData.title;
    const visibleOrg = contactData.type === 'personal' && contactData.org;
    const visibleOrgname = contactData.type === 'personal' && contactData.orgname;
    return (React.createElement("div", { className: styles.infoWrapper },
        renderItems({
            items: emailList,
            label: getIn18Text('YOUXIANG'),
            enableSend: true,
            type: 'email',
        }),
        showSchedule &&
            renderItems({
                items: [getIn18Text('CHAKANRICHENG')],
                label: getIn18Text('RILI'),
                showCopy: false,
                toSchedule: true,
                type: 'schedule',
            }),
        visibleMailRelated &&
            renderItems({
                items: [getIn18Text('CHAKANWANGLAIYOU')],
                label: getIn18Text('YOUJIAN'),
                showCopy: false,
                visibleMailRelated: true,
                type: 'mailRelated',
            }),
        visiblePhone &&
            renderItems({
                items: phoneList,
                label: getIn18Text('DIANHUA'),
                type: 'phone',
            }),
        visibleJob &&
            renderItems({
                items: [(contactData === null || contactData === void 0 ? void 0 : contactData.job) || ''],
                label: getIn18Text('ZHIWEI'),
                showCopy: false,
                type: 'job',
            }),
        visiblePosition &&
            renderItems({
                items: contactData.position.map(item => item.join('/')),
                label: getIn18Text('BUMEN'),
                showCopy: false,
                showPoint: contactData.position.length > 1,
                type: 'position',
            }),
        visibleNumber &&
            renderItems({
                items: [getIn18Text('CHAKAN')],
                label: getIn18Text('CHENGYUAN'),
                showCopy: false,
                toNumber: true,
                type: 'member',
            }),
        visibleRemark &&
            renderItems({
                items: [contactData.remark],
                label: getIn18Text('BEIZHU'),
                showCopy: false,
                type: 'remark',
            }),
        Boolean(personalOrgNameList.length) && (React.createElement("div", { className: styles.infoRows },
            React.createElement("div", { className: styles.infoLabel }, getIn18Text('FENZU')),
            React.createElement("div", { className: styles.infoContent },
                React.createElement("div", { className: styles.personalOrgWrap, "data-test-id": "contact_detail_info_group_list" }, personalOrgNameList.map(item => (React.createElement("div", { className: styles.personalOrgLabel, key: item, "data-test-id": "contact_detail_info_group_item" }, item))))))),
        visibleAdrList
            ? renderItems({
                items: contactData
                    .adrList.filter(item => {
                    return item.trim().length > 0;
                })
                    .map(item => {
                    return item.replace(/;/g, '');
                }),
                label: getIn18Text('LIANXIDIZHI'),
                showCopy: false,
                type: 'address',
            })
            : null,
        visibleBirthday
            ? renderItems({
                items: [dayjs(contactData.birthday).format('YYYY/MM/DD')],
                label: getIn18Text('SHENGRI'),
                showCopy: false,
                type: 'birthday',
            })
            : null,
        visiblePref
            ? renderItems({
                items: [contactData.pref],
                label: getIn18Text('GERENZHUYE'),
                showCopy: true,
                type: 'pref',
            })
            : null,
        visibleOrgname
            ? renderItems({
                items: [contactData.orgname],
                label: getIn18Text('GONGSI/ZUZHI'),
                showCopy: false,
                type: 'orgname',
            })
            : null,
        visibleOrg
            ? renderItems({
                items: [contactData.org],
                label: getIn18Text('BUMEN'),
                showCopy: false,
                type: 'org',
            })
            : null,
        visibleTitle
            ? renderItems({
                items: [contactData.title],
                label: getIn18Text('ZHIWEI'),
                showCopy: false,
                type: 'pos',
            })
            : null,
        visibleRole
            ? renderItems({
                items: [contactData.role],
                label: getIn18Text('JUESE'),
                showCopy: false,
                type: 'role',
            })
            : null,
        memberListVisible && (React.createElement(MemberList, { visible: memberListVisible, user: contactData.accountName, contactName: contactData.contactName, onCancel: () => setMemberListVisible(false) }))));
};
export default ContactDetailInfo;
